export default [
    {
        'displayName': 'Обхват шеи',
        'fieldName': 'neck',
        'keyMirror': 'neckAround',
        'units' : 'см',
    },
    {
        'displayName': 'Обхват груди',
        'fieldName': 'chest',
        'keyMirror': 'chestAround',
        'units' : 'см',
    },
    {
        'displayName': 'Обхват талии',
        'fieldName': 'waist',
        'keyMirror': 'waistAround',
        'units' : 'см',
    },
    {
        'displayName': 'Обхват бедер',
        'fieldName': 'seat',
        'keyMirror': 'seatAround',
        'units' : 'см',
    },
    {
        'displayName': 'Длина изделия',
        'fieldName': 'shirt_length',
        'keyMirror': 'shirtLength',
        'units' : 'см',
    },
    {
        'displayName': 'Длина рукава',
        'fieldName': 'arm_length',
        'keyMirror': 'sleeveLength',
        'units' : 'см',
    },
    {
        'displayName': 'Длина кор.рукава',
        'fieldName': 'short_sleeve_length',
        'keyMirror': 'shortSleeveLength',
        'units' : 'см',
    },
    {
        'displayName': 'Обхват плеча',
        'fieldName': 'biceps',
        'keyMirror': 'bicepsAround',
        'units' : 'см',
    },
    {
        'displayName': 'Обхват запястья',
        'fieldName': 'wrist',
        'keyMirror': 'wristAround',
        'units' : 'см',
    },
    {
        'displayName': 'Рост',
        'fieldName': 'height',
        'keyMirror': 'height',
        'units' : 'см',
    },
]
